import { useInView } from "framer-motion"
import { useRef } from "react"
import Courses from "../courses"


const OurColleges = () => {
    const ref = useRef(null)
    const useIsInView = useInView(ref, { once: true })
    return (
        <div ref={ref} className="grid place-items-center gap-5 my-24">

            <h2 className="w-auto   text-3xl font-bold ">Explore our Colleges</h2>
            <div className="w-full bg-[#F9F9FA] p-8 grid place-items-center py-12">
                <div className="max-w-6xl grid place-items-center">
                    <Courses useIsInView={useIsInView} />
                </div>
            </div>
        </div>
    )
}

export default OurColleges